
/**
 * Submit data to integromat
 * @param object fields 
 * @returns boolean
 */
const submit = (fields, url) => {

    // Headers
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');

    const requestOptions = {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(fields),
        redirect: 'follow'
    }

    if (process.env.NODE_ENV === 'development') {
        console.log({
            url,
            headers: Object.fromEntries(headers),
            form: fields
        })
        return true;
    }

    fetch(url, requestOptions)
        .then(response => response.text())
        .then(result => console.log(result))
        .catch(error => console.log(error));
}

/**
 * Integromat form submit handler
 */
const integromat = {
    estimate: (fields) => {
        const url = `${process.env.REACT_APP_INTEGROMAT_URL}${process.env.REACT_APP_INTEGROMAT_ENDPOINT_ESTIMATE}`
        return submit(fields, url);
    },
    sell: (fields) => {
        const url = `${process.env.REACT_APP_INTEGROMAT_URL}${process.env.REACT_APP_INTEGROMAT_ENDPOINT_SELL}`
        return submit(fields, url);
    }
}

export default integromat;